
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { CategoryGroup } from "@/types/category";

interface CategoryGroupFormProps {
  name: string;
  description: string;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onCancel?: () => void;
  group?: CategoryGroup;
}

export const CategoryGroupForm: React.FC<CategoryGroupFormProps> = ({
  name,
  description,
  isLoading,
  onSubmit,
  onNameChange,
  onDescriptionChange,
  onCancel
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="group-name" className="text-sm font-medium">
          Name
        </label>
        <Input
          id="group-name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Category group name"
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="group-description" className="text-sm font-medium">
          Description
        </label>
        <Input
          id="group-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Category group description (optional)"
        />
      </div>
      <div className="flex gap-2 justify-end">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        )}
        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Saving..." : "Save Category Group"}
        </Button>
      </div>
    </form>
  );
};
